/**
 * AdminModuleNavGroup — draggable "Modules" nav group injected into the
 * repurposed Sidebar for /admin. Wraps the 4 admin modules previously
 * shown as pill buttons in Admin.jsx's PageHeader actions row (Obondo
 * Telemetry, Revenue Analytics, Behavioural Guardrails, Symbol Registry)
 * and lets an admin drag them into their preferred order, persisted per
 * browser via localStorage. Reorder engine lives in SortableNavGroup.jsx
 * (shared with the "Admin Tools" nav group).
 */
import { TrendingUp, ShieldAlert, ListTree } from "lucide-react";
import { MR } from "@/components/Sidebar";
import SortableNavGroup from "@/components/admin/SortableNavGroup";

const STORAGE_KEY = "md_admin_modules_order";

const MODULES = [
    { id: "revenue-analytics",       to: "/admin/analytics/revenue",        label: "Revenue Analytics",       icon: TrendingUp,  testId: "nav-admin-revenue-analytics" },
    { id: "behavioural-guardrails",  to: "/admin/compliance/layer11-audit", label: "Behavioural Guardrails",  icon: ShieldAlert, testId: "nav-admin-guardrails" },
    { id: "symbol-registry",         to: "/admin/symbols",                  label: "Symbol Registry",         icon: ListTree,    testId: "nav-admin-symbol-registry" },
];

export default function AdminModuleNavGroup({ collapsed, onNavigate }) {
    return (
        <div data-testid="admin-modules-nav-group">
            {collapsed ? (
                <div className="my-2 mx-3 h-px" style={{ background: MR.DIVIDER }} aria-hidden />
            ) : (
                <div
                    className="px-3 text-caption uppercase tracking-[0.18em] font-semibold mb-1.5"
                    style={{ color: MR.TEXT_SECONDARY, opacity: 0.85 }}
                >
                    Modules
                </div>
            )}
            <SortableNavGroup storageKey={STORAGE_KEY} items={MODULES} collapsed={collapsed} onNavigate={onNavigate} />
        </div>
    );
}
